import { render, staticRenderFns } from "./AllocateDialog.vue?vue&type=template&id=01d4d98e"
import script from "./AllocateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AllocateDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports